export const TEMPLATE_FILES_PATH = "constants/templates/";
export const SERVICE_1 = window.SERVICE_1;
export const MEDIA = window.MEDIA;
